export const product = () => {

    const jsAnimateProduct = document.querySelector(".js-animate-product");
    let inViewport = false;

    if(jsAnimateProduct){


    const jsAnimateProductReady = document.querySelector(".js-animate-product-ready");
    const pins = document.querySelector(".js-product-pins");


    const canvas = document.getElementById('productCanvas');
    canvas.classList.add("no-loaded");


    
   
    const ctx = canvas.getContext('2d');
    const sprite1 = new Image();
    const sprite2 = new Image();
    sprite1.src = canvas.dataset.spriteFirst;
    sprite2.src = canvas.dataset.spriteSecond;
    const spriteWidth = 750;
    const spriteHeight = 750;
    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;

    const displayWidth = spriteWidth * 1;
    const displayHeight = spriteHeight * 1;
    const offsetX = (canvasWidth - displayWidth) / 2;
    const offsetY = (canvasHeight - displayHeight) / 2;

    let currentSprite = sprite1;
    let frameIndex = 0;
    
    const framesInSprite1 = Number(canvas.dataset.countSprite); // Общее количество кадров в первом спрайте
    const framesInSprite2 = Number(canvas.dataset.countSprite); // Общее количество кадров во втором спрайте

    let totalFrames = framesInSprite1 + framesInSprite2; // Общее количество кадров в анимации

    let animationSpeed = canvas.dataset.animationSpeed;
    let animationStarted = true;


    Promise.all([loadImage(sprite1), loadImage(sprite2)])
    .then(() => {
        console.log("Загрузили");
        canvas.classList.remove("no-loaded");
        startAnimationTrigger();
        animationStarted = false;
    })
    .catch(() => {
        // Если произошла ошибка загрузки изображений, отображаем первый кадр первого спрайта
       // ctx.drawImage(preview, 0, 0, spriteWidth, spriteHeight, 0, 0, canvasWidth, canvasHeight);
    });

    function loadImage(img) {
    return new Promise((resolve, reject) => {
        img.onload = resolve;
        img.onerror = reject;
    });
    }






    function startAnimationProduct() {

        let timeEnd = totalFrames * (100 / animationSpeed);
       

        if(pins){
            setTimeout(function () {
                pins.classList.add("product-pins--active");
            }, timeEnd+500);
        }
  
      
        if (canvas) {
            jsAnimateProduct.classList.remove('js-animate-product-ready');
            ctx.clearRect(0, 0, canvasWidth, canvasHeight);
            //console.log("canvas");
            function animate() {
              
                ctx.clearRect(0, 0, canvasWidth, canvasHeight);
            
                currentSprite = (frameIndex >= framesInSprite1) ? sprite2 : sprite1;
                let cadr = frameIndex % framesInSprite1; 
                ctx.drawImage(
                    currentSprite, 
                    0, (cadr) * spriteHeight, spriteWidth, spriteHeight,
                    offsetX, offsetY, displayWidth, displayHeight
                );
                
                frameIndex++;
                
                if (frameIndex < totalFrames) {
                   
                    setTimeout(animate, 100 / animationSpeed); 
                } else {
                    // Анимация завершена
                }
            }

          animate(); 
          
        }
    }



        function startAnimationTrigger() {
            console.log(inViewport, "inViewport");
            if(inViewport){
                document.querySelector(".productCanvas").classList.remove('productCanvas--preview');
                document.querySelector(".productCanvas").classList.add('productCanvas--runner');
                startAnimationProduct();
                animationStarted = true;
                removeEventListener('scroll', checkScroll, false); // Отключаем событие после запуска анимации
          
            }
        }





        function checkScroll() {
            //console.log("checkScroll");
            
            
            if (!animationStarted && isElementInViewport(jsAnimateProductReady)) {
                inViewport = true;
                startAnimationTrigger();
               // setTimeout(startAnimationProduct, 500);
               
            }
        }
    
        function isElementInViewport(el) {
            var rect = el.getBoundingClientRect();
            //console.log(rect, "rect");

            //console.log(window.innerHeight, "window.innerHeight");
           // console.log(document.documentElement.clientHeight, "document.documentElement.clientHeight");

           // console.log(window.innerWidth, "window.innerWidth");
           // console.log(document.documentElement.clientWidth, "document.documentElement.clientWidth");


            return (
                parseInt(rect.top) >= 0 &&
                parseInt(rect.left) >= 0 &&
                parseInt(rect.bottom) <= (window.innerHeight || document.documentElement.clientHeight) * (5 / 4) &&
                parseInt(rect.right) <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }
    
        window.addEventListener('scroll', checkScroll, false);

        window.addEventListener('touchmove', checkScroll, false);


        
        
        canvas.addEventListener('click', function(event) {
            var rect = canvas.getBoundingClientRect();
            let ratio = 750 / rect.height;
        
            var x = (event.clientX - rect.left) * ratio;
            var y = (event.clientY - rect.top) * ratio;
            console.log("Координаты клика относительно канваса: " + x + ", " + y);
          });
    
    
          canvas.addEventListener('mousemove', function(event) {
                var rect = canvas.getBoundingClientRect();
                let ratio = 750 / rect.height;  // если канвас меньше 
             
                var x = event.clientX - rect.left;
                var y = event.clientY - rect.top;
    
    
               // console.log(y);
          });


          if(pins){
          
            const productPins = pins.querySelectorAll(".product-pin");

            if(productPins.length > 0 ){
                document.addEventListener("click", function(event) {
                    const target = event.target;
                
                    if (!target.classList.contains("product-pin")) {
                        productPins.forEach(pin => {
                            pin.classList.remove('product-pin--active');
                        });
                    }
                });
                
                productPins.forEach(pin => {
                    pin.addEventListener("click", function() {
                        productPins.forEach(pinDel => {
                            pinDel.classList.remove('product-pin--active');
                        });
                        pin.classList.add('product-pin--active');
                    });
                });
            }
        }
    
    }

};
